<template>
	<div>
		<div class="section-title is-small">
			{{ title }}
		</div>
		<div class="section-description is-medium">
			Full name
		</div>
		<AppInput
			v-model="form.FullName"
			size="full"
			color="underline"
			font="light"
			placeholder="Your Name"
		/>
		<div class="section-description is-medium">
			Email
		</div>
		<AppInput
			v-model="form.EMailAddress"
			size="full"
			color="underline"
			placeholder="Your mail"
		/>
		<div class="section-description is-medium section-select">
			Country
		</div>
		<AppSelect
			v-model="form.Country"
			:options="countries"
			option-label="name"
			option-value="name"
			searchable
			placeholder="Type or select your country"
		/>
		<div class="section-description is-medium">
			Youtube Channel URL
		</div>
		<AppInput
			v-model="form.YouTubeChannelURL"
			size="full"
			color="underline"
			placeholder="Enter your Youtube channel URL"
		/>
		<div
			v-if="profilePicture"
			class="profile-picture"
		>
			<div class="section-description is-medium is-white-200">
				Profile picture
			</div>
			<div class="section-items">
				<div class="item-img">
					<img
						src="@/assets/user.svg"
						alt="user"
					>
				</div>
				<AppButton
					size="flex"
					color="outline-light"
				>
					Change profile picture
				</AppButton>
			</div>
		</div>
		<div class="buttons">
			<router-link :to="{name: 'Dashboard'}">
				<AppButton
					size="medium"
					color="outline-light"
					gap="right"
				>
					Cancel
				</AppButton>
			</router-link>
			<AppButton
				v-if="!changesSaved"
				size="medium"
				color="primary"
				:disabled="!madeChanges"
				@click="saveChanges"
			>
				Save changes
			</AppButton>
			<AppButton
				v-if="changesSaved"
				size="medium"
				color="grey"
				item="icon"
			>
				<img
					src="@/assets/check.png"
					class="small-img"
					alt="check"
				>
				Save changes
			</AppButton>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { en as countries } from '@/data/countries';

export default {
	name: 'SettingsAccount',

	data() {
		return {
			title: 'Account settings',
			changesSaved: false,
			madeChanges: false,
			profilePicture: false,
			form: {
				FullName: '',
				EMailAddress: '',
				Country: '',
				Intention: '',
				YouTubeChannelURL: '',
			},
			countries,
		};
	},

	watch: {
		form: {
			handler() {
				this.changesSaved = false;
				this.madeChanges = true;
			},
			deep: true,
		},
	},

	async mounted() {
		this.form = await this.getCurrentUserData();
	},

	methods: {
		...mapActions([
			'getCurrentUserData',
		]),

		...mapActions('auth', [
			'saveProfile',
		]),
		async saveChanges() {
			await this.saveProfile({ ...this.form });
			this.changesSaved = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.section-description {
	color: $color-accent-200;
	margin-top: $gap-5;
	margin-bottom: $gap-05;
}

.buttons {
	display: flex;
	justify-content: flex-end;
	margin-top: $gap-5;

	.button {
		margin-right: $gap-2;

		&:last-child {
			margin-right: 0;
		}
	}
}

.section-select {
	margin-bottom: $gap-2;
}

.section-items {
	display: flex;
	align-items: center;
	margin-top: $gap-3;

	.item-img {
		width: 80px;
		height: 80px;
		border: 1px solid $color-accent-400;
		border-radius: 50%;
		overflow: hidden;
		margin-right: $gap-2;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
